export class StatmentDetail {
    resellerUserName: string;
    resellerFullName: string;
    resellerTransactions: ResellerTransaction[];
    totalDebt: number;
    paymentAmount: number;
    entity: string;
}

export class ResellerTransaction {
    id: number;
    campaignId: number;
    campaign: ResellerCampaign;
    orderId: number;
    invoiceNumber: string;
    invoiceDate: string;
    dueDate: string;
    dueAmount: number;
    lateFeeAmount: number;
    firstDebtApplied: boolean;
    secondDebtApplied: boolean;
    paidAmount: number;
    resolved: boolean;
}

export class ResellerCampaign {
    number: string;
}

export class ResellerPayment {
    id: number;
    resellerTransaction: ResellerTransaction;
    paymentDate: string;
    paidAmount: number;
    paymentSource: string;
    paymentType: string;
}

export const paymentTypeMap = {
    0: 'Archivo',
    1: 'Archivo GZ',
    2: 'Archivo Servicio',
    3: 'Nota de credito',
    4: 'Pago manual',
    5: 'Residual',
    6: 'Legacy',
    7: 'Otro archivo',
    8: 'Pago Anulado',
    9: 'Desconocido',
    10: 'Factura',
    11: 'Desarme',
    12: 'Nota de debito'
};
